/*
 * @Author: xiang.gao xiang.gao@travel-easy.com
 * @Date: 2022-08-08 16:42:54
 * @LastEditors: xiang.gao 57524479+GaoXiang0403@users.noreply.github.com
 * @LastEditTime: 2024-04-26 14:31:41
 * @FilePath: /settlement-frontend/src/main.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Directive, createApp } from "vue";
import App from "./App.vue";

import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";
import * as directives from "@/directives";

//imports for app initialization
//import MockAdapter from "@/core/mock/MockService";
import ApiService from "@/core/services/ApiService";
//import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import { InlineSvgIcon } from "magicbean-saas-common";
import CommonCurrency from "@/components/layout/CommonCurrency.vue";
import CustomCurrency from "@/components/layout/CustomCurrency.vue";
import YearRangePicker from "@/components/picker/year.vue";

import "@/core/plugins/keenthemes";
import "bootstrap";
import { currencyCount } from "./core/directive/function/common";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const Emitter = require("tiny-emitter");
const emitter = new Emitter();

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    // eslint-disable-next-line @typescript-eslint/ban-types
    $currency: {
      currency: typeof currencyCount;
    };
  }
}

const app = createApp(App);

Object.keys(directives).forEach((key) => {
  app.directive(key, (directives as { [key: string]: Directive })[key]);
});

app.config.globalProperties.emitter = emitter;

app.config.globalProperties.$currency = {
  currency: currencyCount,
};

app.use(store);
app.use(router);
app.use(ElementPlus);

ApiService.init(app);
//MockAdapter.init(app);
//initApexCharts(app);
initInlineSvg(app);
app.component("inline-svg-icon", InlineSvgIcon);
app.component("common-currency", CommonCurrency);
app.component("custom-currency", CustomCurrency);
app.component("year-range-picker", YearRangePicker);
initVeeValidate();

app.use(i18n);

app.mount("#app");
